export function addCommas (value) {
  var parts = value.toString().replace(/[^\d.]/g,'').split(".")
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return parts.join(".");
}

export function sanitizePercentInput (value) {
  return value.toString().replace(/[^\d.]/g,'')
}

export function sanitizeNumber (value) {
  let val = value.toString().replace(/[^\d.]/g,'')
  return !isNaN(Number.parseFloat(val)) ? Number.parseFloat(val) : 0
}

export function formatPercentageValue (value) {
  return addCommas(Math.round10(parseFloat(value), -3))
}

export function formatDollars (value) {
  return addCommas(value)
}

export function formatMoney (value) {
  return addCommas(formatDollarValue(value).toFixed(2))
}

export function formatDollarValue (value) {
  return Math.round10(parseFloat(value), -2)
}

export function round10 (value, precision) {
  return Math.round10(value, precision);
}

export function numberShortener (value) {
  if (value <= 10 ** 3) {
    return value;
  } else if (value < 10 ** 6) {
    return Math.floor(value/(10 ** 3)) + 'K';
  } else if (value < 10 ** 9) {
    return Math.floor(value/(10 ** 6)) + 'M';
  } else if (value < 10 ** 12) {
    return Math.floor(value/(10 ** 9)) + 'B';
  }
}

export function formatThousands (value) {
  const MILLIONS = 1000000
  const THOUSANDS = 1000

  if (value >= MILLIONS) {
    return addCommas(value/MILLIONS) + 'M'
  } else if (value >= THOUSANDS) {
    return addCommas(value/THOUSANDS) + 'k'
  } else {
    return addCommas(value)
  }
}

export function formatMonthsAndYears (value) {
  const months = value % 12
  const years = Math.floor(value/12)
  let output = ''

  if (years > 0) {
    output += years === 1 ? `${years} year ` : `${years} years `
  }
  if (months > 0) {
    output += months === 1 ? `${months} month` : `${months} months`
  }
  if (years === 0 && months === 0) {
    output += '0 months'
  }

  return output
}

// Closure
(function() {
  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // If the value is negative...
    if (value < 0) {
      return -decimalAdjust(type, -value, exp);
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  // Decimal round
  if (!Math.round10) {
    Math.round10 = function(value, exp) {
      return decimalAdjust('round', value, exp);
    };
  }
  // Decimal floor
  if (!Math.floor10) {
    Math.floor10 = function(value, exp) {
      return decimalAdjust('floor', value, exp);
    };
  }
  // Decimal ceil
  if (!Math.ceil10) {
    Math.ceil10 = function(value, exp) {
      return decimalAdjust('ceil', value, exp);
    };
  }
})();


// WEBPACK FOOTER //
// ./src/config/utils.js